import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Modifier } from '@prlw/core/monitor/types/common';
import { MainTableColumnId } from '@prlw/core/monitor/types/main-table';
import { MainTableService } from '../table/main-table/main-table.service';
import { MainTableModifiersService } from '@prlw/core/monitor/main-table-modifiers.service';

@Component({
  selector: 'prlw-table-modifiers-overlay',
  templateUrl: './modifiers-overlay.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifiersOverlayContainer {
  @Output() public readonly closeOverlay = new EventEmitter<void>();
  public readonly modifier$: Observable<Modifier>;
  public readonly sortDirection$: Observable<'ASC' | 'DES' | null>;

  constructor(
    private readonly mainTableService: MainTableService,
    private readonly mainTableModifiersService: MainTableModifiersService,
  ) {
    this.modifier$ = mainTableModifiersService.modifier$;
    this.sortDirection$ = mainTableService.sorting$.pipe(
      map((sorting) =>
        sorting.columnId === MainTableColumnId.LOCAL_PRICE
          ? sorting.direction
          : null,
      ),
    );
  }

  public close(): void {
    this.closeOverlay.emit();
  }

  public setModifier(modifier: Modifier): void {
    this.mainTableModifiersService.updateModifier(modifier);
  }

  public setSort(sortDirection: 'ASC' | 'DES'): void {
    this.mainTableService.sortColumn(
      MainTableColumnId.LOCAL_PRICE,
      sortDirection,
    );
  }
}
